/**
 * R14 : sélectionne la RPC à appeler selon le rôle.
 * - admin/superadmin : get_users_list (liste complète, gated par migration 00009)
 * - tout autre rôle  : get_assignable_users (admin/superadmin uniquement,
 *   accessible à tout authenticated, migration 00047)
 */
export function selectUsersRpc(
  role: string | undefined
): 'get_users_list' | 'get_assignable_users' {
  return role === 'admin' || role === 'superadmin' ? 'get_users_list' : 'get_assignable_users';
}
